<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/CH_contents">About the authors</a></h1>
<p class="fo"><span class="bold">John Stott</span> had a worldwide ministry as a church leader, a Bible expositor and the author of many award-winning books. He was Rector Emeritus of All Souls, Langham Place, London, and Founder-President of the Langham Partnership.</p>
<p class="fo_space"><span class="bold">Tim Chester</span> is Pastor of Grace Church, Boroughbridge, North Yorkshire, Chair of Keswick Ministries and the author of more than forty books.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CH_authors.vue?62864cdc